import { BaseTable, Button, Modal } from 'components'
import { ProductPreviewType } from '../types'
import { convertNumber } from 'utils'

type ModalPreviewType = {
  data: ProductPreviewType[]
  show: boolean
  handleCloseModal: () => void
  handleSubmitModal: () => void
}

export const ModalPreview = ({ data, show, handleCloseModal, handleSubmitModal }: ModalPreviewType) => {
  const borderTH = "border-2 border-[#A6AEBF]"

  return (
    <div>
      {show && (
        <Modal isOpen title="DATA FORM EXCEL" closeModal={handleCloseModal}>
          <Modal.Body>
            <div className="overflow-x-auto">
              <BaseTable>
                <thead className='bg-[#EEEEEE]'>
                  <tr>
                    <th className={borderTH} rowSpan={2}>NO</th>
                    <th className={borderTH} colSpan={11}>PRODUCT DATA</th>
                    <th className={borderTH} colSpan={13}>PRODUCT PROFILE</th>
                    <th className={borderTH} colSpan={6}>PRODUCT BUYING</th>
                    <th className={borderTH} colSpan={12}>PRODUCT SELLING</th>
                  </tr>
                  <tr>
                    <th className={`${borderTH} min-w-[120px]`}>BARCODE*</th>
                    <th className={`${borderTH} min-w-[350px]`}>DESCRIPTION*</th>
                    <th className={`${borderTH} min-w-[120px]`}>GROUP</th>
                    <th className={`${borderTH} min-w-[120px]`}>STYLE</th>
                    <th className={`${borderTH} min-w-[120px]`}>SIZE</th>
                    <th className={borderTH}>WEIGHT</th>
                    <th className={borderTH}>UNIT WEIGHT</th>
                    <th className={`${borderTH} min-w-[120px]`}>COLOUR</th>
                    <th className={`${borderTH} min-w-[120px]`}>CATEGORY</th>
                    <th className={`${borderTH} min-w-[200px]`}>MARKET SEGMENT</th>
                    <th className={`${borderTH} min-w-[120px]`}>MATERIAL</th>
                    <th className={borderTH}>BUILD</th>
                    <th className={borderTH}>SHOP</th>
                    <th className={borderTH}>SERVICE</th>
                    <th className={`${borderTH} min-w-[300px]`}>ONLINE</th>
                    <th className={borderTH}>I BUY*</th>
                    <th className={borderTH}>I SELL*</th>
                    <th className={borderTH}>I INVENTORY*</th>
                    <th className={borderTH} colSpan={2}>ACC. BUY</th>
                    <th className={borderTH} colSpan={2}>ACC. SELL</th>
                    <th className={borderTH} colSpan={2}>ACC. INVENTORY</th>
                    <th className={`${borderTH} min-w-[200px]`}>VENDOR</th>
                    <th className={`${borderTH} min-w-[150px]`}>PRICE</th>
                    <th className={`${borderTH} min-w-[120px]`}>TAX</th>
                    <th className={borderTH}>BUYING UNIT</th>
                    <th className={borderTH}>QTY CONVENTION</th>
                    <th className={borderTH}>UNIT CONVENTION</th>
                    <th className={borderTH}>OVER HEAD(%)</th>
                    <th className={borderTH}>SALE TAX(%)</th>
                    <th className={borderTH}>OTHERS(%)</th>
                    <th className={borderTH}>SELLING UNIT</th>
                    <th className={borderTH}>QTY CONVENTION</th>
                    <th className={`${borderTH} min-w-[150px]`}>RETAIL</th>
                    <th className={`${borderTH} min-w-[150px]`}>WHOLESALE</th>
                    <th className={`${borderTH} min-w-[150px]`}>DISTRIBUTOR</th>
                    <th className={`${borderTH} min-w-[150px]`}>FACTORY</th>
                    <th className={`${borderTH} min-w-[150px]`}>ONLINE</th>
                    <th className={`${borderTH} min-w-[150px]`}>SPECIAL ARANGEMENT</th>
                    <th className={borderTH}>TAX CODE WHEN SOLD(%)</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((val, index) => (
                    <tr key={index} className="hover:bg-gray-100">
                      <td className={`${borderTH} text-center`}>{index + 1}</td>
                      <td className={`${borderTH} text-center`}>{val.BARCODE ?? "-"}</td>
                      <td className={borderTH}>{val.DESCRIPTION ?? "-"}</td>
                      <td className={borderTH}>{val.GROUP ?? "-"}</td>
                      <td className={borderTH}>{val.STYLE ?? "-"}</td>
                      <td className={borderTH}>{val.SIZE ?? "-"}</td>
                      <td className={`${borderTH} text-center`}>{val.WEIGHT ? convertNumber(val.WEIGHT).intoNormalAmount : "-"}</td>
                      <td className={borderTH}>{val.UNIT_WEIGHT ?? "-"}</td>
                      <td className={borderTH}>{val.COLOUR ?? "-"}</td>
                      <td className={borderTH}>{val.CATEGORY ?? "-"}</td>
                      <td className={borderTH}>{val.MARKET_SEGMENT ?? "-"}</td>
                      <td className={borderTH}>{val.MATERIAL ?? "-"}</td>
                      <td className={`${borderTH} text-center`}>{val.BUILD ?? "-"}</td>
                      <td className={`${borderTH} text-center`}>{val.SHOP ?? "-"}</td>
                      <td className={`${borderTH} text-center`}>{val.SERVICE ?? "-"}</td>
                      <td className={borderTH}>{val.ONLINE_DESCRIPTION ?? "-"}</td>
                      <td className={`${borderTH} text-center`}>{val.I_BUY ?? "-"}</td>
                      <td className={`${borderTH} text-center`}>{val.I_SELL ?? "-"}</td>
                      <td className={`${borderTH} text-center`}>{val.I_INVENTORY ?? "-"}</td>
                      <td className={`${borderTH} text-nowrap`}>{val.NO_ACC_BUY ?? "-"}</td>
                      <td className={`${borderTH} text-nowrap`}>{val.ACC_BUY_NAME ?? "-"}</td>
                      <td className={`${borderTH} text-nowrap`}>{val.NO_ACC_SELL ?? "-"}</td>
                      <td className={`${borderTH} text-nowrap`}>{val.ACC_SELL_NAME ?? "-"}</td>
                      <td className={`${borderTH} text-nowrap`}>{val.NO_ACC_INVENTORY ?? "-"}</td>
                      <td className={`${borderTH} text-nowrap`}>{val.ACC_INVENTORY_NAME ?? "-"}</td>
                      <td className={borderTH}>{val.VENDOR ?? "-"}</td>
                      <td className='text-right'>{val.PRICE_BUY ? convertNumber(val.PRICE_BUY).intoCurrency : "-"}</td>
                      <td className={borderTH}>{val.BUY_TAX ?? "-"}</td>
                      <td className={borderTH}>{val.BUYING_UNIT ?? "-"}</td>
                      <td className={`${borderTH} text-center`}>{val.QTY_BUY_CONVERSION ? convertNumber(val.QTY_BUY_CONVERSION).intoNormalAmount : "-"}</td>
                      <td className={borderTH}>{val.UNIT_BUY_CONVERSION ?? "-"}</td>
                      <td className={`${borderTH} text-center`}>{val.OVERHEAD ? convertNumber(val.OVERHEAD).intoNormalAmount : "-"}</td>
                      <td className={`${borderTH} text-center`}>{val.SALE_TAX ? convertNumber(val.SALE_TAX).intoNormalAmount : "-"}</td>
                      <td className={`${borderTH} text-center`}>{val.OTHERS ? convertNumber(val.OTHERS).intoNormalAmount : "-"}</td>
                      <td className={borderTH}>{val.SELLING_UNIT ?? "-"}</td>
                      <td className={`${borderTH} text-center`}>{val.QTY_SELL_CONVERSION ? convertNumber(val.QTY_SELL_CONVERSION).intoNormalAmount : "-"}</td>
                      <td className={`${borderTH} text-right`}>{val.RETAIL_PRICE_IN_SELLING_UNIT ? convertNumber(val.RETAIL_PRICE_IN_SELLING_UNIT).intoCurrency : "-"}</td>
                      <td className={`${borderTH} text-right`}>{val.WHOLESALE ? convertNumber(val.WHOLESALE).intoCurrency : "-"}</td>
                      <td className={`${borderTH} text-right`}>{val.DISTRIBUTOR ? convertNumber(val.DISTRIBUTOR).intoCurrency : "-"}</td>
                      <td className={`${borderTH} text-right`}>{val.FACTORY ? convertNumber(val.FACTORY).intoCurrency : "-"}</td>
                      <td className={`${borderTH} text-right`}>{val.ONLINE ? convertNumber(val.ONLINE).intoCurrency : "-"}</td>
                      <td className={`${borderTH} text-right`}>{val.SPECIAL_ARANGEMENT ? convertNumber(val.SPECIAL_ARANGEMENT).intoCurrency : "-"}</td>
                      <td className={borderTH}>{val.TAX_CODE_WHEN_SOLD ?? "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </BaseTable>
            </div>

            <Noted />
          </Modal.Body>
          <Modal.Footer className="text-end">
              <div className="flex justify-end">
              <div className="flex gap-3">
                  <Button color="error" onClick={handleCloseModal}>CANCEL</Button>
                  <Button color="primary" onClick={handleSubmitModal}>OK</Button>
              </div>
              </div>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  )
}

const Noted = () => (
  <>
    <div className="mt-5"><b>NB : </b></div>
    <div>
      <b>The data comes from the excel file you sent, it has not been corrected according to Hawk standards, after saving please review it first in the upload file list</b>
    </div>
  </>
)